import api from './client';
import type {
  AtualizarMetaCompraRequest,
  CriarMetaCompraRequest,
  DimensaoDrilldown,
  MetaCompra,
  MetaCompraDashboard,
  MetaCompraDashboardResponse,
  MetaCompraHistoricoMes,
  MetaCompraHistoricoResponse,
  MetaCompraResponse,
  MetasCompraResponse,
  PedidoDrilldown,
  PedidoDrilldownResponse,
} from '../types/metaCompra';

export const metaCompraApi = {
  listar: async (filtros: { anoMes?: string; empresa?: string }): Promise<MetaCompra[]> => {
    const params = new URLSearchParams();
    if (filtros.anoMes) params.set('anoMes', filtros.anoMes);
    if (filtros.empresa) params.set('empresa', filtros.empresa);
    const qs = params.toString();
    const resp = await api.get<MetasCompraResponse>(`/compras/metas${qs ? `?${qs}` : ''}`);
    return resp.data.data;
  },

  obter: async (id: number): Promise<MetaCompra> => {
    const resp = await api.get<MetaCompraResponse>(`/compras/metas/${id}`);
    return resp.data.data;
  },

  criar: async (req: CriarMetaCompraRequest): Promise<MetaCompra> => {
    const resp = await api.post<MetaCompraResponse>('/compras/metas', req);
    return resp.data.data;
  },

  atualizar: async (id: number, req: AtualizarMetaCompraRequest): Promise<MetaCompra> => {
    const resp = await api.put<MetaCompraResponse>(`/compras/metas/${id}`, req);
    return resp.data.data;
  },

  excluir: async (id: number): Promise<void> => {
    await api.delete(`/compras/metas/${id}`);
  },

  dashboard: async (anoMes: string, empresas: string[]): Promise<MetaCompraDashboard> => {
    const params = new URLSearchParams();
    params.set('anoMes', anoMes);
    // Backend lê [FromQuery] string[] empresa → repetir o param
    empresas.forEach((e) => params.append('empresa', e));
    const resp = await api.get<MetaCompraDashboardResponse>(`/compras/metas/dashboard?${params.toString()}`);
    return resp.data.data;
  },

  dashboardHistorico: async (
    anoMes: string,
    empresas: string[],
    meses = 6,
  ): Promise<MetaCompraHistoricoMes[]> => {
    const params = new URLSearchParams();
    params.set('anoMes', anoMes);
    params.set('meses', String(meses));
    empresas.forEach((e) => params.append('empresa', e));
    const resp = await api.get<MetaCompraHistoricoResponse>(
      `/compras/metas/dashboard/historico?${params.toString()}`,
    );
    return resp.data.data;
  },

  drilldown: async (
    anoMes: string,
    empresas: string[],
    dimensao: DimensaoDrilldown,
    codigo: string,
  ): Promise<PedidoDrilldown[]> => {
    const params = new URLSearchParams();
    params.set('anoMes', anoMes);
    params.set('dimensao', dimensao);
    params.set('codigo', codigo);
    empresas.forEach((e) => params.append('empresa', e));
    const resp = await api.get<PedidoDrilldownResponse>(`/compras/metas/drilldown?${params.toString()}`);
    return resp.data.data;
  },
};
